import { z } from 'zod'

export const clubeFormSchema = z.object({
  nome: z.string().min(1, 'Nome obrigatorio').max(150),
  razao_social: z.string().max(200).optional().or(z.literal('')).transform(v => v || null),
  nome_fantasia: z.string().max(200).optional().or(z.literal('')).transform(v => v || null),
  cidade: z.string().min(1, 'Cidade obrigatoria').max(120),
  estado: z.string().length(2, 'Estado deve ter 2 letras').transform(v => v.toUpperCase()),
  telefone: z.string().max(20).optional().or(z.literal('')).transform(v => v || null),
  email: z.string().email('Email invalido').max(100).optional().or(z.literal('')).transform(v => v || null),
  logradouro: z.string().max(200).optional().or(z.literal('')).transform(v => v || null),
  numero: z.string().max(20).optional().or(z.literal('')).transform(v => v || null),
  bairro: z.string().max(100).optional().or(z.literal('')).transform(v => v || null),
  cep: z.string().max(9).optional().or(z.literal('')).transform(v => v || null),
  inscricao_estadual: z.string().max(30).optional().or(z.literal('')).transform(v => v || null),
  cnpj: z.string().max(18).optional().or(z.literal('')).transform(v => v || null),
  cr_clube: z.string().max(50).optional().or(z.literal('')).transform(v => v || null),
})

export type ClubeFormData = z.infer<typeof clubeFormSchema>
